import { render } from "./ContactsContent.vue?vue&type=template&id=3c8a81b0&scoped=true"
import script from "./ContactsContent.vue?vue&type=script&lang=js"
export * from "./ContactsContent.vue?vue&type=script&lang=js"

import "./ContactsContent.vue?vue&type=style&index=0&id=3c8a81b0&scoped=true&lang=css"

import exportComponent from "D:\\DEV\\Actual\\SanElita\\elita_web_site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c8a81b0"]])

export default __exports__